var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50375 0C9.50375 0 11.3281 1.26786 13.4077 2.125C15.3744 2.93948 16.9494 3.02925 16.9988 3.03207C16.9997 3.03212 17.0001 3.03214 17 3.03214V9.33572C17 11.0679 16.7185 12.9571 14.3911 15.0857C12.0676 17.2107 9.5 18 9.5 18C9.5 18 6.93618 17.2143 4.60886 15.0857C2.28528 12.9607 2 11.0679 2 9.33572V3.03214C2 3.03214 3.5991 2.95357 5.59985 2.125C7.67943 1.26786 9.50375 0 9.50375 0ZM13.7803 7.03033C14.0732 6.73744 14.0732 6.26256 13.7803 5.96967C13.4874 5.67678 13.0126 5.67678 12.7197 5.96967L8.25 10.4393L6.78033 8.96967C6.48744 8.67678 6.01256 8.67678 5.71967 8.96967C5.42678 9.26256 5.42678 9.73744 5.71967 10.0303L7.71967 12.0303C8.01256 12.3232 8.48744 12.3232 8.78033 12.0303L13.7803 7.03033Z",
    fill: "#56AC14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shield_icon.f60eb106cd578b30ba4589d11a6120bb.svg";
export { ForwardRef as ReactComponent };